import { useEffect } from "react";
import { _t } from "core/language";
import PageHeader from "core/components/Header/PageHeader";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import CDialog from "core/components/CDialog";
import Button from "core/components/form-controls/Button";
import LoadingAI from "./../components/Loading";
import { useCustomNavigate } from 'core/hooks/useCustomNavigate'
import { RouterName, route } from "core/router";
import { useAiChef, useResetAiChef } from "./../hooks/aiChef";
import useImagePicker, { useGetImagePicker } from "core/hooks/useImagePicker";
import { AiChefTypeEnum } from './../store/types';
import {
  ImageTypeEnums,
} from 'core/store/upload/actions';
import { nl2br } from 'core/utils/helper';

const ImageIngredientsLoadingPage = () => {
  useScrollToTop()
  const navigate = useCustomNavigate()
  const { onReset } = useResetAiChef()
  const aiChefImageIngredient = useGetImagePicker(
    'aiChefImageIngredient',
    false
  )
  const { handleButtonClick, handleRetryUpload } = useImagePicker({
    multiple: false,
    name: 'aiChefImageIngredient',
    property: ImageTypeEnums.TEMPORARY,
    openType: aiChefImageIngredient.openType,
  })
  const {
    isBoth,
    setIsBoth,
    redirectTo,
    message,
    open,
    setOpen,
    retryUpload,
    lastPage,
    showLoading,
    updateRequestType,
  } = useAiChef(AiChefTypeEnum.ingredient, aiChefImageIngredient)

  const onCancel = () => {
    onReset(false)
    navigate(lastPage)
  }

  useEffect(() => {
    (window as any)._nativeResponseFileCancel = () => {
      onCancel()
    }
  }, [onCancel])

  const handleSubmit = () => {
    setOpen(false)
    if (retryUpload) {
      handleRetryUpload()
      // onCancel()
    } else if (redirectTo) {
      return navigate(route(redirectTo))
    } else {
      onReset(false)
      handleButtonClick()
    }
  }

  return (
    <AppLayout>
      <PageHeader
        title={_t('aiChef.ingredient.title')}
        sticky
        // showCart={false}
      />
      <div className="px-4 pt-7 space-y-7">
        {showLoading ? <LoadingAI /> : null}
      </div>
      <CDialog
        open={open}
        closeModal={() => setOpen(false)}
        handleSubmit={handleSubmit}
        onCancel={onCancel}
        // hideCancel={hideCancel}
        classNamechildren="px-[8px]"
        submitText={(retryUpload || message === 'unknow') ? _t('aiChef.retry') : _t('aiChef.yes')}
        closeText={(retryUpload || message === 'unknow') ? _t('aiChef.cancel') : _t('aiChef.no')}
        disableCloseOnBackDrop
      >
        <div className="w-full text-center">
          <p
            className="text-sm tracking-tighter"
            dangerouslySetInnerHTML={{__html: nl2br(_t(`aiChef.msg.${message}`))}}
          />
        </div>
      </CDialog>
      <CDialog
        open={isBoth}
        closeModal={() => setIsBoth(false)}
        classNamechildren="px-[8px]"
        isButton={false}
        onCancel={onCancel}
        disableCloseOnBackDrop
      >
        <div className="w-full text-center">
          <p
            className="text-sm tracking-tighter"
            dangerouslySetInnerHTML={{__html: nl2br(_t('aiChef.msg.bothType'))}}
          />
        </div>
        <div className="pt-[30px] w-full flex justify-center gap-2">
          <Button
            type="button"
            label={_t('aiChef.goToIngredient')}
            onClickBtn={() => {
              updateRequestType(AiChefTypeEnum.ingredient)
              navigate(route(RouterName.AI_CHEF_INGREDIENTS))
            }}
            size={'sm'}
            classBtn={`px-2`}
          />
          <Button
            type="button"
            label={_t('aiChef.goToRecipe')}
            onClickBtn={() => {
              updateRequestType(AiChefTypeEnum.meal)
              navigate(route(RouterName.AI_CHEF_RECIPES))
            }}
            size={'sm'}
            classBtn={`px-2`}
          />
        </div>
      </CDialog>
      <BottomNavigation activeIndex={2}/>
    </AppLayout>
  );
};

export default ImageIngredientsLoadingPage;
